export default {
  props: {
    navSections: {
      type: Array,
      default: () => []
    },
    // --- //
    isMobile: {
      type: Boolean,
      required: true
    },
    drawingMenus: {
      type: Object,
      default: () => ({})
    },
    navVisible: {
      type: Boolean,
      default: false
    },
    searchVisible: {
      type: Boolean,
      default: false
    },
    // --- //
    bannerHeight: {
      type: Object,
      default: () => ({})
    },
    menuHeight: {
      type: Object,
      default: () => ({})
    },
    // --- //
    findYourRing: {
      type: Object,
      default: () => ({})
    },
    footerNav: {
      type: Object,
      default: () => ({})
    },
  },
  methods: {
    hideSearch() {
      this.$emit('hideSearch')
    },
    hideDrawingMenu(id) {
      this.$emit('hideDrawingMenu', id)
    },
    showDrawingMenu(id) {
      this.$emit('showDrawingMenu', id)
    },
    closeSubMenus() {
      this.$emit('closeAllDrawingMenu')
    }
  }
}
